export enum RelationshipType {
  Parent = "parent",
  Grandparent = "grandparent",
  Guardian = "guardian",
  AuthorizedIndividual = "authorized_individual"
}

export const RelationshipTypeLabels: Record<RelationshipType, string> = {
  [RelationshipType.Parent]: "Parent",
  [RelationshipType.Grandparent]: "Grandparent",
  [RelationshipType.Guardian]: "Guardian",
  [RelationshipType.AuthorizedIndividual]: "Authorized Individual"
};

export interface ParentGuardian {
  id: string;
  first_name: string;
  last_name: string;
  phone_number: string;
  email_address: string;
  student_count?: number;
  relationship?: RelationshipType;
}